import React from 'react';

import MatchRow from 'app/modules/Betting/components/MatchTable/components/MatchRow';

import styles from 'app/modules/Betting/components/MatchTable/MatchTable.module.scss';

type MatchRowProps = {
  matchIds: Array<number>;
};

export const MatchRows = ({
  matchIds,
}: MatchRowProps) => {
  return (
    <ul className={styles.matchList}>
      {[...matchIds].map((matchId: number) => {
        return (
          <MatchRow key={`match-${matchId}`}
                    matchId={matchId} />
        );
      })}
    </ul>
  );
};
